class ClubMemberRegistration {
  constructor() {
    this.init();
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source');
    
    if (source === 'club' && this.isCustomerLoggedIn()) {
      // small delay to ensure Shopify customer object is fully loaded
      setTimeout(() => {
        this.handleClubRegistration();
      }, 500);
    } else {
      console.log('not logged in')
    }
  }

  async handleClubRegistration() {
    if (!this.isCustomerLoggedIn()) {
      console.log('Customer not logged in, cannot process club registration');
      return;
    }
    
    try {
      const response = await fetch('/apps/backend/api/v1/club-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          email: window?.Shopify?.customer?.email,
          id: window?.Shopify?.customer?.id
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Club member tagged successfully:', result);
        
        this.cleanUpUrl();

      } else {
        console.error('Failed to tag club member:');
        console.log(await response?.text())
      }
      
    } catch (error) {
      console.error('Error tagging club member:', error);
    }
  }

  cleanUpUrl() {
    const url = new URL(window.location);
    url.searchParams.delete('source');
    
    // Update URL without page reload
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }

  isCustomerLoggedIn() {
    return window?.Shopify && 
           window?.Shopify?.customer && 
           window?.Shopify?.customer?.id && 
           window?.Shopify?.customer?.email;
  }
}

let clubMemberRegistrationInstance = null;

document.addEventListener('DOMContentLoaded', () => {
    if (!clubMemberRegistrationInstance) {
        clubMemberRegistrationInstance = new ClubMemberRegistration();
    }
});

// Also initialize on page load for better compatibility
window.addEventListener('load', () => {
    if (!clubMemberRegistrationInstance) {
        clubMemberRegistrationInstance = new ClubMemberRegistration();
    }
});

// Export for potential use in other scripts
window.ClubMemberRegistration = ClubMemberRegistration;